import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Inject, Injectable, PLATFORM_ID } from "@angular/core";
import { isPlatformBrowser } from "@angular/common";
import { BehaviorSubject } from "rxjs";
import { environment } from "../../../environments/environment";
import { User } from '../models/user.model';
import { SharedApiService } from 'src/app/shared/serviceLayer/shared-service';
import { ToastrService } from "ngx-toastr";
import { TranslateService } from '@ngx-translate/core';

@Injectable()

export class AuthService {

    public tokenKey: any;
    public userId: any;
    private enableParticlesSubject = new BehaviorSubject<boolean>(false);
    enableParticles$ = this.enableParticlesSubject.asObservable();
    
    url: any = environment.URL;

    constructor(
        private http: HttpClient,
        private sharedApiService: SharedApiService,
        private toster:ToastrService,
        private translate: TranslateService,
        @Inject(PLATFORM_ID) private platformId: Object
    ) { }

    login(user: User) {
        return this.http.post<any>(this.url + 'auth/login', user);
    }

    reset(email: any) {
        return this.http.patch<any>(this.url + 'auth/reset-password', email);
    }


    changePassword(data: any) {
        return this.http.patch(this.url +'api/auth/change-password', data);
    }

    showParticles() {
      if (!isPlatformBrowser(this.platformId)) return;
      const particlesContainer = document.getElementById('particles-js');
      if (particlesContainer) {
        particlesContainer.style.display = 'block';
      }
    }

    hideParticles() {
      if (!isPlatformBrowser(this.platformId)) return;
      const particlesContainer = document.getElementById('particles-js');
      if (particlesContainer) {
        particlesContainer.style.display = 'none';
      }
    }

  saveToken(token: string): void {
    if (!isPlatformBrowser(this.platformId)) return;
    localStorage.setItem('token', token);
    localStorage.setItem('refresh', Date.now().toString());
  }

  getToken(): string | null {
    if (!isPlatformBrowser(this.platformId)) return null;
    return localStorage.getItem('token');
  }

  removeToken(): void {
    if (!isPlatformBrowser(this.platformId)) return;
    localStorage.removeItem('token');
  }

  isLoggedIn(): boolean {
    return this.getToken() !== null;
  }

  clearLocalStorage() {
    if (!isPlatformBrowser(this.platformId)) return;
    localStorage.removeItem('token');
    localStorage.removeItem('currentUser');
    localStorage.removeItem('lang');
    localStorage.removeItem('sortTypeKey');
    localStorage.removeItem('sortTypeOrder');
    localStorage.removeItem('isViewTypeList');
}


logout() {
  let data: any = this.currentUserValue;
  let data2 = {
    userId: data ? data?._id : this.userId,
    token: this.getToken()
  }
  const params = new HttpParams()
    .set('userId', data2.userId)
    .set('token', data2.token);

  const headers = new HttpHeaders({
    'Content-Type': 'application/x-www-form-urlencoded' // Set content type
  });
  if (data2.userId) {
    const token = localStorage.getItem('token');
    if (!token) {
      localStorage.removeItem('token');
      localStorage.removeItem('currentUser');
      localStorage.removeItem('lang');
      localStorage.removeItem('sortTypeKey');
      localStorage.removeItem('sortTypeOrder');
      localStorage.removeItem('isViewTypeList');
    } else {
      this.sharedApiService.logout(data2).subscribe((res: any) => {
        if (res.status) {
          this.removeToken();
        }
      });
    }
  } else {
    this.removeToken();
  }
  this.clearLocalStorage();

}

public get currentUserValue() {
  if (!isPlatformBrowser(this.platformId)) return null;
  const data = localStorage.getItem('currentUser');
  if (data && data !== 'undefined') return JSON.parse(data);
  return null;
}

}